import { useState } from "react";
import { useTranslation } from "react-i18next";

import BaseModal from "@/components_v2/Modal/BaseModal";
import FilterGroup from "@/features/certifications/community-flags/components/FilterGroup";
import NotCountedCard from "@/features/certifications/community-flags/components/NotCountedCard";
import {
  ALL,
  NOT_COUNTED_MODAL_WIDTH,
  TYPE_FILTERS,
} from "@/features/certifications/community-flags/constants";
import {
  filterGrades,
  sortNewestDecisionFirst,
} from "@/features/certifications/community-flags/utils";
import {
  NotCountedModalProps,
  TypeFilter,
} from "@/features/certifications/community-flags/types";

import "../styles.css";

const NotCountedModal = ({
  open,
  certification,
  grades,
  onClose,
}: NotCountedModalProps) => {
  const { t } = useTranslation();
  const [type, setType] = useState<TypeFilter>(ALL);
  const shown = sortNewestDecisionFirst(filterGrades(grades, type));

  let content;
  if (grades.length === 0) {
    content = (
      <div className="flags-empty flex flex-col items-center gap-100">
        <span className="body-m-medium">
          {t("certification.admin.communityFlags.notCounted.none.title")}
        </span>

        <span className="body-s-regular">
          {t("certification.admin.communityFlags.notCounted.none.body")}
        </span>
      </div>
    );
  } else if (shown.length === 0) {
    content = (
      <div className="flags-empty flex flex-col items-center gap-100">
        <span className="body-m-medium">
          {t(`certification.admin.communityFlags.notCounted.filtered.${type}`)}
        </span>

        <span className="body-s-regular">
          {t("certification.admin.communityFlags.tryAll")}
        </span>
      </div>
    );
  } else {
    content = (
      <div className="flex flex-col gap-300">
        {shown.map((grade) => (
          <NotCountedCard
            key={grade.id}
            certification={certification}
            grade={grade}
          />
        ))}
      </div>
    );
  }

  return (
    <BaseModal
      open={open}
      width={NOT_COUNTED_MODAL_WIDTH}
      onCancel={onClose}
      title={t("certification.admin.communityFlags.notCounted.title")}
      subtitle={t("certification.admin.communityFlags.notCounted.subtitle")}
      footer={null}
    >
      <div className="flex flex-col gap-400">
        <FilterGroup
          label={t("certification.admin.communityFlags.type")}
          options={TYPE_FILTERS}
          value={type}
          getLabel={(option) =>
            t(`certification.admin.communityFlags.types.${option}`)
          }
          onChange={setType}
        />

        {content}
      </div>
    </BaseModal>
  );
};

export default NotCountedModal;
